import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import Button from '../../../../../../components/global/Button';
import Angle from '../../../../../../components/global/Angle';
import { getAsset } from '../../../../../../util/assets';
import { isVGBContext } from '../../../../../../util/album';
import useOpenModal from '../../../../../../hooks/useOpenModal';
import { CONTRIBUTOR_SHARE_MODAL } from '../../../../../../constants/modals';
import { getCelebratedPersonName } from '../../../AlbumFolder/FreemiumEvents/SpecialtyAlbumGreetingModal/helpers';
import ContributorShare from '../../../../components/ContributorShare';
import ContactCircleSaveModal from '../../../../../../components/global/ContactCircleSaveModal/modal';
import ContactCircleShareModal from '../../../../../../components/global/ContactCircleShareModal';
import {
  isNativeAppWebView,
  postNativeAppAlbumSlideshowDesignerDismiss,
} from '../../../../../../services/native-bridge/native-apps-interface';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
    album_subtype: PropTypes.string,
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

const VideoSlideshowNullState = ({ album, history, location }) => {
  const openModal = useOpenModal();
  const isNativeView = isNativeAppWebView();
  const albumId = album?.id;

  const handleBackClick = () => {
    if (isNativeView) {
      postNativeAppAlbumSlideshowDesignerDismiss();
    } else {
      history.goBack();
    }
  };

  const handleInviteClick = () => {
    openModal(CONTRIBUTOR_SHARE_MODAL, { albumId });
  };

  const handleAddVideoClick = () => {
    history.push({
      pathname: `/contributors/upload/${albumId}/record-video`,
      search: `?${qs.stringify({
        next: location.pathname,
        generic_upload: isVGBContext(album) ? '0' : '1',
      })}`,
    });
  };

  const celebratedName = getCelebratedPersonName(
    album?.album_subtype,
    album?.root_album_folder?.event_settings,
    false,
    album?.root_album_folder?.account?.organization_name ??
      album?.root_album_folder?.account?.name,
  );

  return (
    <div className="video-slideshow-null-state">
      <div className="video-slideshow-null-state-header">
        <div className="video-slideshow-null-state-confetti" />
        <Button
          btnStyle="link"
          className="video-slideshow-null-state-back-button"
          onClick={handleBackClick}
        >
          <Angle direction="left" />
        </Button>
        <h1 className="video-slideshow-null-state-title">Group Video</h1>
      </div>

      <div className="video-slideshow-null-state-content">
        <div className="video-slideshow-null-state-emoji">
          <img src={getAsset('/waldo-icon.svg')} alt="Waldo" width="64" />
        </div>

        <img
          src={getAsset('/group-video-null-page.png')}
          alt="Group video illustration"
          className="video-slideshow-null-state-image"
        />

        <h2 className="video-slideshow-null-state-heading">
          Let&apos;s make a memorable Group Video
          <br />
          for {celebratedName}!
        </h2>

        <div className="video-slideshow-null-state-actions">
          <Button
            btnStyle="primary"
            btnOutline
            className="video-slideshow-null-state-button"
            onClick={handleInviteClick}
          >
            Invite others to add their video
          </Button>
          <Button
            btnStyle="primary"
            className="video-slideshow-null-state-button"
            onClick={handleAddVideoClick}
          >
            Add a video
          </Button>
        </div>
      </div>
      <ContributorShare />
      <ContactCircleSaveModal />
      <ContactCircleShareModal />
    </div>
  );
};

VideoSlideshowNullState.propTypes = propTypes;

export default compose(withRouter)(VideoSlideshowNullState);
